export enum PlanningDraftExportType {
  STOPS = "STOPS",
  ROUTES = "ROUTES",
  ROUTES_LOADING = "ROUTES_LOADING",
  SUMMARY = "SUMMARY"
}
